import { render, staticRenderFns } from "./vodPlayerSuggestion.vue?vue&type=template&id=084f8cfa&scoped=true&"
import script from "./vodPlayerSuggestion.vue?vue&type=script&lang=js&"
export * from "./vodPlayerSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./vodPlayerSuggestion.vue?vue&type=style&index=0&lang=css&"
import style1 from "./vodPlayerSuggestion.vue?vue&type=style&index=1&id=084f8cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f8cfa",
  null
  
)

export default component.exports